<!--
  Language switcher in the header.
  Click-toggle; outside-click and Escape close it (see HostListener handlers
  in the component). Two-letter `currentCode()` is shown alongside the
  globe icon so the active language is always visible at a glance.
  Each option carries its country flag image from `public/images/flags`.
-->
<div class="lang-switcher" [class.open]="open()">
  <button
    type="button"
    class="lang-trigger"
    [attr.aria-label]="'Change language'"
    [attr.aria-haspopup]="'menu'"
    [attr.aria-expanded]="open()"
    (click)="toggle()">
    <i class="pi pi-globe" aria-hidden="true"></i>
    <span class="lang-code">{{ currentCode() }}</span>
  </button>

  @if (open()) {
    <ul class="lang-menu" role="menu">
      @for (lang of languages; track lang.code) {
        <li role="none">
          <button type="button" role="menuitem" class="lang-option" [class.active]="isActive(lang)" (click)="selectLang(lang)">
            <img class="lang-flag" [src]="lang.flag" alt="" aria-hidden="true" />
            <span class="lang-label">{{ lang.label }}</span>
            @if (isActive(lang)) {
              <i class="pi pi-check" aria-hidden="true"></i>
            }
          </button>
        </li>
      }
    </ul>
  }
</div>
